<template>
  <div>
    <v-main>
      <v-form v-model="formValidate">
        <v-container fluid>
          <app-headline title="รายงานสรุปค่าทำบัตร" />

          <req-card-report-search />

          <app-headline
            v-if="tableVisible"
            :title="
              'รายการจากวันที่ ' +
                $dateFormatByLang($route.query.StartDate) +
                ' ถึงวันที่ ' +
                $dateFormatByLang($route.query.EndDate)
            "
          />

          <req-card-report-table
            v-if="tableVisible"
            :header="header"
            :DataTable="dataTable"
          >
            <template v-slot:footer>
              <div
                style="display: flex;justify-content: flex-end;"
                class="pa-2"
              >
                <v-btn
                  @click="apiExcelFile"
                  :disabled="dataTable.length < 1"
                  color="primary"
                  >Export</v-btn
                >
              </div>
            </template>
          </req-card-report-table>
        </v-container>
      </v-form>
    </v-main>
  </div>
</template>

<script>
import ReqCardReportTable from '@/components/reqcard/ReqCardReportTable.vue'
import ReqCardReportSearch from '@/components/reqcard/ReqCardReportSearch.vue'
export default {
  components: {
    ReqCardReportTable,
    ReqCardReportSearch
  },
  data() {
    return {
      dataTable: []
    }
  },

  watch: {
    $route() {
      this.onSearch()
    }
  },

  mounted() {
    this.onSearch()
  },

  computed: {
    header() {
      return [
        { text: 'กองทุน', value: 'fundNumber' },
        { text: 'หน่วยงาน', value: 'institutionNumber' },
        { text: 'แผนงาน', value: 'workNumber' },
        { text: 'ผังบัญชี', value: 'auditNumber' },
        { text: 'หลักสูตร', value: 'syllabusNumber' },
        { text: 'รหัสงบประมาณ', value: 'budgetNumber' },
        { text: 'แหล่งเงิน', value: 'moneyNumber' },
        { text: 'จำนวนเงิน', value: 'amountTotal' },
        { text: 'วันที่รับชำระ', value: 'dateAndReceiptNumberFull' }
      ]
    },
    tableVisible() {
      return !!this.$route.query.StartDate && !!this.$route.query.EndDate
    }
  },

  methods: {
    async onSearch() {
      let body = {
        StartDate: this.$route.query.StartDate || '',
        EndDate: this.$route.query.EndDate || ''
      }
      const res = await this.apiExcelData(body)
      let data = []
      res.forEach(item => {
        data.push(item.rowTop)
        data.push(item.rowDown)
      })
      this.dataTable = data
    },
    async apiExcelData(body) {
      try {
        const res = await this.$store.dispatch(
          'reqCard/getExcelDataForFND',
          body
        )
        // console.log(res.data.data)
        return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    },
    async apiExcelFile() {
      try {
        let body = {
          StartDate: this.$route.query.StartDate || '',
          EndDate: this.$route.query.EndDate || ''
        }
        const res = await this.$store.dispatch(
          'reqCard/getExcelFileForFND',
          body
        )
        var fileURL = window.URL.createObjectURL(new Blob([res.data]))
        var fileLink = document.createElement('a')
        // console.log(res.data)
        fileLink.href = fileURL
        fileLink.download =
          'Summary - ' + body.StartDate + ' - ' + body.EndDate + '.xlsx'
        // document.body.appendChild(fileLink)

        fileLink.click()
        // return res.data?.data
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
